export const formatCurrency = (value: number) => {
  var formatter = new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency: 'EUR',
  });

  return formatter.format(value);
};
